// extracted by mini-css-extract-plugin
export default {"modal":"DeleteAccountModal_modal__fCk8T","crossButton":"DeleteAccountModal_crossButton__RlY+K"};